const givingProfilePath = "/giving/profile"

export const ProfileNavItems = [
  { label: "Overview", path: givingProfilePath },
  {
    label: "Donation history",
    path: `${givingProfilePath}/donations`,
  },
  {
    label: "Planned giving",
    path: `${givingProfilePath}/planned`,
  },
  {
    label: "Payment methods",
    path: `${givingProfilePath}/payment-methods`,
  },
  {
    label: "Text2Give",
    path: `${givingProfilePath}/text-to-give`,
  },
  {
    label: "Notifications",
    path: `${givingProfilePath}/notifications`,
  },
  {
    label: "Statements",
    path: `${givingProfilePath}/statements`,
  },
] as const

export type ProfileNav = (typeof ProfileNavItems)[number]

export type SendsReceiptsValue = "always" | "never"

export type SendsReceiptsOption = {
  label: string
  value: SendsReceiptsValue
}

export type GivingPersonNotificationsAttributes = {
  email_addresses: string[]
  giving_preferred_email_address: string | null
  sends_receipts: SendsReceiptsValue
}
